import { Currency } from '@rd/types';
import {
  CurrencyActions,
  CurrencyActionTypes,
} from '../actions/currency.actions';

export interface CurrencyState {
  selected: Currency | null;
}

const initialState: CurrencyState = {
  selected: null,
};

export function currencyReducer(
  state: CurrencyState = initialState,
  action: CurrencyActions,
): CurrencyState {
  switch (action.type) {
    case CurrencyActionTypes.CHANGE_CURRENCY:
      return {
        ...state,
      };
    case CurrencyActionTypes.CHANGE_CURRENCY_SUCCESS:
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
}
